module.exports = __webpack_public_path__ + "img/power-swiper-item (15).0b656d90.png";